import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom'

// pages
import Home from './pages/Home'
import About from './pages/About'
import Quiz from './pages/Quiz'
import Faq1 from './pages/help/Faq'
import Contact1 from './pages/help/Contact'
import Tips from './pages/help/tips'
import TrafficLaws from './pages/learn/trafficLaws'
import TrafficSigns from './pages/learn/trafficSigns'
import RoadSafety from './pages/learn/roadSafety'
import VehicleKnowledge from './pages/learn/vehicleKnowledge'
import NotFound from './pages/NotFound'
// import Careers, { careersLoader } from './pages/careers/Careers'
import Careers from './pages/careers/Careers'
import CareerDetails, { careerDetailsLoader } from "./pages/careers/CareerDetails"
import CareersError from './pages/careers/CareersError'
import Contact from './pages/learn/Contact'
import QuizType from './pages/quiz/quizType'
import Privacy from './pages/Privacy'
import Quiz1 from './pages/quiz/type'
// layouts
import RootLayout from './layouts/RootLayout'
import LearnLayout from './layouts/LearnLayout'
import CareersLayout from './layouts/CareersLayout'
import QuizLayout from './layouts/QuizLayout'
import HelpLayout from './layouts/HelpLayout'
import StartLayout from './layouts/StartLayout'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<Home />} />
      <Route path='test/AR/:id' element={<Quiz1 />} />
      <Route path='test/EN/:id' element={<Quiz1 />} />
      <Route path='test/HE/:id' element={<Quiz1 />} />
      <Route path="about" element={<About />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="quiz" element={<QuizLayout />} >
        <Route path="AR" element={<QuizType />} />
        <Route path="HE" element={<QuizType />} />
        <Route path="EN" element={<QuizType />} />
        {/* <Route path="1" element={<Quiz1/>} /> */}


      </Route>
      <Route path="learn" element={<LearnLayout />}>
        {/* <Route path="faq" element={<Faq />} /> */}
        {/* <Route path="contact" element={<Contact/>} /> */}
        <Route path="trafficLaws" element={<TrafficLaws />} />
        <Route path="trafficSigns" element={<TrafficSigns />} />
        <Route path="roadSafety" element={<RoadSafety />} />
        <Route path="vehicleKnowledge" element={<VehicleKnowledge />} />
      </Route>

      {/* STARTLAYOUT  */}
      <Route path="start" element={<StartLayout />}>

        <Route path="quiz" element={<QuizLayout />} >
          <Route path="AR" element={<QuizType />} />
          <Route path="HE" element={<QuizType />} />
          <Route path="EN" element={<QuizType />} />  
        </Route>
        <Route path="learn" element={<LearnLayout />}>
        {/* <Route path="faq" element={<Faq />} /> */}
        {/* <Route path="contact" element={<Contact/>} /> */}
        <Route path="trafficLaws" element={<TrafficLaws/>} />
        <Route path="trafficSigns" element={<TrafficSigns/>} />
        <Route path="roadSafety" element={<RoadSafety/>} />
        <Route path="vehicleKnowledge" element={<VehicleKnowledge/>} />
      </Route>
      </Route>
      <Route path="careers" element={<CareersLayout />} errorElement={<CareersError />}>
        <Route
          index
          element={<Careers />}
        // loader={careersLoader}
        // errorElement={<CareersError />}
        />
        <Route
          path=":_id"
          element={<CareerDetails />}
        // loader={careerDetailsLoader}
        />
      </Route>
      <Route path="help" element={<HelpLayout />}>
        <Route path="faq" element={<Faq1 />} />
        <Route path="tips" element={<Tips />} />
        <Route path="contact" element={<Contact1 />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Route>
  )
)

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App
